export function genPreviewPath(value: string) {
  const prefix = process.env.PREVIEW_RESOURCES_PREFIX || "";
  return `${prefix}${value}`;
}

export function removePreviewPrefix(value: string) {
  const prefix = process.env.PREVIEW_RESOURCES_PREFIX || "";
  let result = value;
  if (value?.startsWith(`${prefix}`)) {
    result = result.replace(prefix, "");
  }
  return result;
}

export const isEmptyString = (string?: string) => {
  if (!string) return true;
  if (string === "<p></p>") return true;
  return string.trim().length === 0;
};
